import React from 'react';
import * as S from './styled';
export const Toolbar = ({ leftContent, centerContent, rightContent }) => (React.createElement(S.Container, null,
    leftContent && React.createElement("div", null, leftContent),
    centerContent && React.createElement(S.CenterContent, null, centerContent),
    rightContent && React.createElement("div", null, rightContent)));
